export default __webpack_public_path__ + "static/media/weezticket-no-icon.69252974.png";